export function validateAlphabets(value) {
  let isError = "";
  let pattern = "^[A-Za-z ]+$";
  let regex = new RegExp(pattern);
  if (!regex.test(value)) {
    isError = "Please enter only alphabets";
  }
  return isError;
}

export function validateNumbers(value) {
  let isError = "";
  let pattern = "^[0-9]+$";
  let regex = new RegExp(pattern);
  if (!regex.test(value)) {
    isError = "Please enter values without decimal";
  }
  return isError;
}

export function validateEmail(value) {
  console.log("emailArray", value);

  const pattern = /^[a-zA-Z0-9._%+-]+@godrej\.com$/;
  const regex = new RegExp(pattern);
  const invalidEmails = [];

  for (const emailObj of value) {
    const email = emailObj.EmailId.trim();
    if (!regex.test(email)) {
      invalidEmails.push(email);
    }
  }
  if (invalidEmails.length > 0) {
    return "Please enter a valid email address in the format XYZ@godrej.com";
  } else {
    return "";
  }
}
  

export function validateAlphaNumeric(value) {
  let isError = "";
  let pattern = "^[A-Za-z0-9 ]+$";
  let regex = new RegExp(pattern);
  if (!regex.test(value)) {
    isError = "Special charaters not allowed";
  }
  return isError;
}

export function validateNumberWithTwoDecimalPlaces(value) {
  let isError = "";
  let pattern = "^[0-9]+(\\.[0-9]{1,2})?$";
  let regex = new RegExp(pattern);

  if (!regex.test(value)) {
    isError =
      "Please enter a number with up to two decimal places (e.g., '123', '45.67').";
  }
  return isError;
}

export function validateCurrentDate(value) {
  let isError = "";
  const currentDate = new Date();
  const inputDate = new Date(value);
  currentDate.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  if (inputDate < currentDate) {
    isError = "Please enter date greater than or equal to today's date"; // Invalid date
  } else {
    isError = ""; // Valid date
  }
  return isError;
}

export function validateFutureDate(value) {
  let isError = "";
  const currentDate = new Date();
  const inputDate = new Date(value);
  currentDate.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  if (inputDate > currentDate) {
    isError = "Date of purchase cannot be a future date"; // Invalid date
    return { isValid: false, message: "Date of purchase cannot be a future date" };
  } else {
    return { isValid: true, message: "" };
  }

}

export function validateEmailAddress(email) {
  let isError = "";
  const regex = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;
  if (!regex.test(String(email).toLowerCase())) {
    isError = "Please enter a valid email address";
  }
  if (email.endsWith(".")) {
    isError = "Email address cannot end with full stop";
  }
  return isError;
}

export function validateDates(startDate, endDate) {
  let isError ;
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (end < start) {
    isError = true;
  }
  return isError;
}

export function validateEmailId(value) {
  let isError = "";
  const pattern = /^[a-zA-Z0-9.]+@godrej.com$/;
  let regex = new RegExp(pattern);
  if (!regex.test(value)) {
      isError = "Please Enter Valid Email id in the format XYZ@godrej.com";
  }
  return isError;
}

export function validateJWTStructure(token) {
  let isError = "";
  const jwtPattern = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;
  
  if (!jwtPattern.test(token)) {
    isError = "Invalid token format";
  }
  return isError;
}
